// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 222) return "static/chunks/vendors.sravni-52adfa0cc8ea5322.js";
	if (chunkId === 893) return "static/chunks/893-58ed2ecf7c5664f3.js";
	if (chunkId === 300) return "static/chunks/300-24a8e4da868976f7.js";
	if (chunkId === 928) return "static/chunks/928-01f5e068b2022d3e.js";
	if (chunkId === 637) return "static/chunks/637-9538aa312df82b17.js";
	if (chunkId === 832) return "static/chunks/832-eee7f14bc4d85cef.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"296":"ea88be26","987":"react-lottie"}[chunkId] || chunkId) + "." + {"203":"f6474b468c85406a","296":"708e47fd560a6f87","458":"083952b47f420a1c","548":"124e9fbb6c3daf70","562":"ec6e2ace869d3930","606":"b526f040a8713cd6","987":"932b9eecaffb4c28"}[chunkId] + ".js";
};